import { Close, Search } from '@mui/icons-material';
import { Drawer, Typography, Stack, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import GenSearch from './GenSearch';
import EmptyList from './GlobalSearch/EmptyList';
import LoadingList from './GlobalSearch/LoadingList';
import ResultsList from './GlobalSearch/ResultsList';

const showResults = (loading, orders, hasNextPage, sentryRef) => {
  if (!loading && !orders.length) return <EmptyList />;
  return (
    <>
      {orders?.map((order, index) => (
        <ResultsList
          vin={order.vehicle.vin}
          stockNumber={order.stockNumber}
          woNumber={order.woNumber}
          index={index}
          vendorOrderId={order.vendorOrderId}
          key={index}
        />
      ))}
      {(loading || hasNextPage) && <LoadingList forwardRef={sentryRef} />}
    </>
  );
};

export default function GlobalSearch({
  open,
  onOpen,
  onClose,
  query,
  setQuery,
  orders,
  loading,
  hasNextPage,
  onLoadMore,
  color,
}) {
  const { t } = useTranslation('global');
  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore,
  });
  return (
    <>
      <IconButton onClick={onOpen} sx={{ color }}>
        <Search />
      </IconButton>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        sx={{ zIndex: 1300 }}
        PaperProps={{
          sx: { width: { md: '540px', xs: '375px' } },
        }}
      >
        <Stack direction="row" justifyContent="space-between" p={3} pb={1.5}>
          <Typography variant="h6">{t('globalSearch.title')}</Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Stack>
        <Stack p={3} pb={1.5}>
          <GenSearch
            searchTerm={filter => {
              setQuery(filter);
            }}
            sx={{
              minWidth: { md: '490px' },
            }}
            autoFocus={true}
            placeholder={
              <>
                <Typography sx={{ fontSize: '10px' }}>
                  {t('globalSearch.tooltip.text1')}
                </Typography>
                <Typography sx={{ fontSize: '10px' }}>
                  {t('globalSearch.tooltip.text2')}
                </Typography>
              </>
            }
          />
        </Stack>
        <Stack p={3} pt={1.5}>
          {query ? showResults(loading, orders, hasNextPage, sentryRef) : ''}
        </Stack>
      </Drawer>
    </>
  );
}
